module.exports = __webpack_public_path__ + "static/img/hangyezeren.8b3aad4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutUS/honors/hangyezeren.png
// module id = NYbz
// module chunks = 7